import { defineAbility } from "@casl/ability";

const accountTypeMap = {
	0: "View",
	1: "User",
	2: "Admin",
	3: "Super Admin",
};

export default defineAbility((can, cannot) => {
	let user = JSON.parse(localStorage.getItem("user"));
	try {
		console.log(
			"%cUser:",
			"font-weight: bold; text-decoration: underline; font-size: 16px;",
			"\nFull Name:",
			user.firstName,
			user.lastName,
			"\nEmail:",
			user.email,
			"\nRefreshToken:",
			user.refreshToken,
			"\nTheme:",
			user.theme
		);
	} catch (error) {
		console.error(
			"Cannot access user properties. \nReason: USER NOT LOGGED IN"
		);
	}
	if (user != null) {
		const accountTypeName = accountTypeMap[user.accountType];
		console.log(
			"user.accountType = ",
			user.accountType,
			"\nAccount Type Name:",
			accountTypeName
		);
		if (user.accountType == 3) {
			can("manage", "all");
		} else {
			can("read", "all");
			cannot("delete", "User");
		}
	}
});
